export default "__VITE_ASSET__DsAlJmyP__"